import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-locked",
  "use": "icon-locked-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-locked\"><path d=\"M8 8c-.8 0-1.5.7-1.5 1.5S7.2 11 8 11s1.5-.7 1.5-1.5S8.8 8 8 8m0 2c-.3 0-.5-.2-.5-.5S7.7 9 8 9s.5.2.5.5-.2.5-.5.5\" /><path d=\"M12 5h-1V4c0-1.7-1.3-3-3-3S5 2.3 5 4v1H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2M6 4c0-1.1.9-2 2-2s2 .9 2 2v1H6zm7 8c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h8c.6 0 1 .4 1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol